import { Divider, Form, Input, InputNumber, Radio } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
// import ManagementPost from './ManagePost'
import { getListUserDepartment } from '../../services/postservice'
import { listManageRequest } from '../../services/requestservice'
import openNotification from '../common/Notification/openNotification '
import styles from './styles.module.scss'
import { formatCurrencyLabel, formatMoney } from '../../utils/helpers'

const FormPost = ({
  form,
  // handleSearch,
  listDepartment,
  listUser,
  LabelType,
  labelWatch,
  ProductType,
  typeRealEstateOps,
  listRequest,
  cities,
  districts,
  towns,
  postType,
  onChangeProject,
  onChangePostType,
  onChangeCity,
  onChangeDistrict,
  onChangeDepartment,
  recordId,
  demandOps,
  typeOfRealEstateOps,
  apartmentLocationOptions,
  directionOptions,
  furnitureOptions,
  procedureOptions,
  legalOptions,
  currentStatusOpstions,
  postStatusOptions,
  postSecurityOptions,
  projectLibrary,
  handleProjectNameChange,
  packageListFeeWeb,
  packageId
}) => {
  const [priceLabel, setPriceLabel] = useState('')
  const originalPrice = packageListFeeWeb.find((e) => e.id === packageId)
    ?.packageProperties.originalPrice
  const timeEx = packageListFeeWeb.find((e) => e.id === packageId)
    ?.packageProperties?.timeEx
  const discount =
    packageListFeeWeb.find((e) => e.id === packageId)?.packageProperties
      ?.promotion || 0
  const visibleFields = useMemo(() => {
    return {
      apartment_code:
        ['1', '2'].includes(labelWatch) && ['1'].includes(postType),

      alley:
        ['1', '2'].includes(labelWatch) && ['2', '3', '4'].includes(postType),

      acreage:
        (['1', '2'].includes(labelWatch) &&
          ['1', '2', '3', '4'].includes(postType)) ||
        (['3', '4'].includes(labelWatch) && ['2', '3', '4'].includes(postType)),

      area_outside:
        ['1', '2', '3', '4'].includes(labelWatch) &&
        ['2', '3', '4'].includes(postType),

      number_of_floor: ['2', '3'].includes(postType),

      number_of_bedrooms: ['1', '3'].includes(postType),

      apartment_location: ['3', '4'].includes(labelWatch),

      direction: ['3', '4'].includes(labelWatch),
      project_id: ['1', '2'].includes(labelWatch),
      procedure: ['1', '2', '3'].includes(labelWatch),
      furniture: ['1', '2', '3'].includes(labelWatch)
    }
  }, [labelWatch, postType])

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        // onFinish={handleSearch}
        labelAlign="right"
        style={{
          // marginTop: 10,
          overflow: 'auto',
          overflowX: 'hidden',
          padding: '0px 10px'
        }}
        initialValues={{ image_360: [''] }}
        onValuesChange={(changedValues) => {
          if ('title' in changedValues) {
            isTitleManuallyEditedRef.current = true
          }
        }}
      >
        <div className={styles.formAdd}>
          <Form.Item
            label=""
            name="id"
            style={{ display: 'none', marginBottom: 0 }}
          >
            <Input />
          </Form.Item>
          <Divider orientation="left">Thông tin cơ bản</Divider>

          <SelectField
            label="Nhu cầu"
            name="label"
            required={true}
            options={demandOps.filter((item) =>
              ['1', '2'].includes(item.value)
            )}
            placeholder="Chọn nhu cầu"
            form={form}
            disabled
          />
          <SelectField
            label="Loại BĐS"
            name="postType"
            required={true}
            options={typeOfRealEstateOps}
            onChange={onChangePostType}
            disabled
          />
          <SelectField
            label="Loại hình BĐS"
            name="typeRealEstate"
            required={true}
            options={typeRealEstateOps}
            disabled
          />
          {visibleFields.project_id && (
            <SelectField
              label="Chọn tên dự án (nếu có)"
              name="projectId"
              // required={true}
              options={projectLibrary}
              onChange={handleProjectNameChange}
            />
          )}
          <SelectField
            label="Tỉnh/Thành phố"
            name="cityCode"
            required={true}
            onChange={onChangeCity}
            options={cities}
          />
          <SelectField
            label="Quận/Huyện"
            name="districtCode"
            required={true}
            onChange={onChangeDistrict}
            options={districts}
          />
          <SelectField
            label={`Phường/Xã`}
            name="townCode"
            required={true}
            options={towns}
          />

          <InputField label="Đường/phố" name="street" form={form} />
        </div>
        <Divider orientation="left">Thông tin theo Loại BDS</Divider>
        <div className={styles.formAdd}>
          <InputField
            label="Tiêu đề"
            name="title"
            form={form}
            required
            placeholder="Nhu cầu + [Loại hình BĐS đã chọn] + Tên dự án (nếu có)"
          />
          {visibleFields.apartment_code && (
            <InputField
              label="Mã căn hộ"
              name="apartmentCode"
              form={form}
              placeholder="Nhập mã căn hộ"
            />
          )}
          {visibleFields.alley && (
            <InputField
              label="Số địa chỉ"
              name="alley"
              form={form}
              placeholder="Nhập số địa chỉ"
            />
          )}

          {visibleFields.acreage && (
            <InputField
              form={form}
              label="Diện tích (m2)"
              name="acreage"
              placeholder="Nhập diện tích"
              // className={styles.InputNumber}
            />
          )}
          {visibleFields.area_outside && (
            <InputField
              form={form}
              label="Mặt tiền (m)"
              name="area_outside"
              placeholder="Nhập mặt tiền"
              className={styles.InputNumber}
            />
          )}
          {visibleFields.number_of_floor && (
            <InputField
              label="Số tầng"
              name="number_of_floor"
              form={form}
              placeholder="Nhập số tầng"
            />
          )}
          {visibleFields.number_of_bedrooms && (
            <InputField
              label="Số phòng ngủ"
              name="numberOfBedrooms"
              form={form}
              placeholder="Nhập số phòng ngủ"
            />
          )}
          {visibleFields.number_of_bedrooms && (
            <InputField
              label="Số phòng WC"
              name="numberOfWc"
              form={form}
              placeholder="Nhập số phòng WC"
            />
          )}

          {/* {visibleFields.apartment_location && ( */}
          <SelectField
            form={form}
            label="Vị trí"
            name="apartmentLocation"
            options={apartmentLocationOptions}
          />
          {/* )} */}
          {/* {visibleFields.direction && ( */}
          <SelectField
            form={form}
            label="Hướng"
            name="direction"
            options={directionOptions}
          />
          <SelectField
            form={form}
            label="Giấy tờ pháp lý"
            name="legal"
            options={legalOptions}
          />
          {visibleFields.furniture && (
            <SelectField
              form={form}
              label="Nội thất"
              name="furniture"
              options={furnitureOptions}
            />
          )}
          {/* )} */}
          {/* 
          <Form.Item
            label={`Tài chính:  ${priceLabel}`}
            name="price"
            // className={styles.formItem}
          > */}
          <InputField
            form={form}
            label={`Giá: ${formatCurrencyLabel(
              String(form.getFieldValue('price'))?.replaceAll('.', '')
            )}`}
            name="price"
            placeholder="Nhập tài chính"
            onBlur={() => {
              const rawValue = form.getFieldValue('price')
              form.setFields([
                {
                  name: 'price',
                  value: rawValue // Đảm bảo giá trị luôn đúng kiểu số
                }
              ])
            }}
            onChange={(value) => {
              setPriceLabel(value)
            }}
            // className={styles.InputNumber}
            formatter={(value) => {
              if (!value) return ''
              return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            }}
            parser={(value) => (value ? value.replace(/\./g, '') : '')}
            maxLength={255}
          />

          {/* </Form.Item> */}
          {visibleFields.project_id && (
            <SelectField
              label="Phí giao dịch"
              name="procedure"
              options={procedureOptions}
            />
          )}
        </div>
        <Divider orientation="left">Gói tin</Divider>
        <div className={styles.formAdd}>
          <SelectField
            label="Gói đăng tin"
            name="packageId"
            options={packageListFeeWeb}
            disabled
          />
          <InputField
            label="Số ngày đăng tin"
            value={timeEx ? `${timeEx} ngày` : ''}
            readOnly
            disabled
            tabIndex={-1}
            style={{
              pointerEvents: 'none',
              background: '#f5f5f5'
            }}
          />
        </div>
        <Divider orientation="left">Tổng tiền cho gói đăng tin đã chọn</Divider>
        <div className={styles.formAdd}>
          <InputField
            label="Đơn giá/ngày"
            value={formatMoney(originalPrice ? `${originalPrice}` : '')}
            readOnly
            disabled
            tabIndex={-1}
            style={{
              pointerEvents: 'none',
              background: '#f5f5f5'
            }}
          />

          <InputField
            label="Thành tiền"
            value={formatMoney(
              originalPrice && timeEx
                ? `${Number(timeEx) * Number(originalPrice)}`
                : ''
            )}
            readOnly
            disabled
            tabIndex={-1}
            style={{
              pointerEvents: 'none',
              background: '#f5f5f5'
            }}
          />
          <InputField
            label="Khuyến mãi"
            value={`${discount}%`}
            readOnly
            disabled
            tabIndex={-1}
            style={{
              pointerEvents: 'none',
              background: '#f5f5f5'
            }}
          />
          <InputField
            label="Tổng thanh toán"
            value={formatMoney(
              Number(timeEx) * Number(originalPrice) -
                (Number(timeEx) * Number(originalPrice) * Number(discount)) /
                  100
            )}
            readOnly
            disabled
            tabIndex={-1}
            style={{
              pointerEvents: 'none',
              background: '#f5f5f5'
            }}
          />
        </div>

        <Form.Item
          label="Mô tả"
          name="description"
          style={{ padding: '0px 8px' }}
        >
          <Input.TextArea
            onBlur={(e) => {
              form.setFields([
                {
                  name: 'description',
                  value: e.target.value?.trim()
                }
              ])
            }}
            placeholder="Nhập nội dung"
            maxLength={255}
          />
        </Form.Item>

        <Divider orientation="left">Thông tin cá nhân</Divider>
        <div className={styles.formAddBottom}>
          <InputField
            label="Họ và tên khách hàng"
            name="customer_name"
            form={form}
          />
          <InputField
            label="Số điện thoại"
            name="customer_phone_number"
            form={form}
            rules={[
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve()

                  // Cho phép phân tách bằng dấu , hoặc -
                  const phoneNumbers = value.split(/[,|-]/).map((p) => p.trim())

                  const invalidNumbers = phoneNumbers.filter(
                    (number) => !/^0\d{9}$/.test(number)
                  )

                  if (invalidNumbers.length > 0) {
                    return Promise.reject(
                      new Error(
                        'Mỗi số điện thoại phải có 10 chữ số và bắt đầu bằng 0. Phân tách bằng "," hoặc "-".'
                      )
                    )
                  }

                  return Promise.resolve()
                }
              }
            ]}
          />
        </div>

        <Form.Item
          label="Xác nhận định danh"
          name="type_user"
          style={{ padding: '0px 8px' }}
        >
          <Radio.Group
            options={[
              { label: 'Khách hàng', value: '0' },
              { label: 'Môi giới bất động sản', value: '1' }
            ]}
          />
        </Form.Item>
      </Form>
    </>
  )
}

export default FormPost
